import { Typography } from "@mui/material";
import useCloseConfirmationStatus from "common/hooks/useCloseConfirmationStatus";
import React, { PropsWithChildren } from "react";
import { Prompt } from "react-router-dom";
import ConfirmationModal from "./ConfirmationModal";

type EntaLeavingPromptProps = {
  message?: string;
  isUpdatePending?: boolean;
};

const preventExit = (event: BeforeUnloadEvent) => {
  const e = event || window.event;
  e.preventDefault();
  if (e) {
    e.returnValue = "";
  }
  return "";
};

export const MESSAGE_CONFIRM_DISCARD_CHANGES: string = "Changes will be lost.";

const EntaLeavingPrompt: React.FC<PropsWithChildren<EntaLeavingPromptProps>> = (
  props
): React.ReactElement => {
  const {
    isDirty,
    closeConfirmationStatus,
    setCloseConfirmed,
    resetCloseConfirmationStatus,
  } = useCloseConfirmationStatus();
  const { children } = props;

  if (isDirty) {
    const isAlreadyDefined = window.onbeforeunload === preventExit;

    //este evento, advertira al usuario en caso de F5, refresh o al cerrar tab/browser
    if (!isAlreadyDefined) window.onbeforeunload = preventExit;
  } else if (!isDirty) window.onbeforeunload = () => undefined;

  //Este componente detecta que estamos navegando dentro de react, a otra vista
  return (
    <>
      {children}
      <Prompt when={isDirty} message={MESSAGE_CONFIRM_DISCARD_CHANGES} />
      <ConfirmationModal
        title={MESSAGE_CONFIRM_DISCARD_CHANGES}
        open={isDirty && closeConfirmationStatus === "confirmationRequested"}
        onConfirm={() => setCloseConfirmed()}
        onCancel={() => resetCloseConfirmationStatus()}
        confirmLabel="Yes, leave"
        cancelLabel="Cancel"
        mainButtonType="error"
        defaultAction="confirm"
      >
        <Typography variant="body1" color="initial">
          Are you sure you want to leave? There are some changes without save.
          Do you want to continue?
        </Typography>
      </ConfirmationModal>
    </>
  );
};

export default EntaLeavingPrompt;
